module.exports = __webpack_public_path__ + "static/blue-sun-zoom-61251ba9cc4e8d8bc6219e871e208d51.jpg";